import { render, staticRenderFns } from "./fangan.vue?vue&type=template&id=4c7c215e"
import script from "./fangan.vue?vue&type=script&lang=js"
export * from "./fangan.vue?vue&type=script&lang=js"
import style0 from "./fangan.vue?vue&type=style&index=0&id=4c7c215e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports